<div class="staff-in-team-container">
  <ng-container *ngIf="startRender;then groupfield;else fake"></ng-container>

  <app-search-field [form]="form" placeholder="職員検索"></app-search-field>
  <div class="horizontal-line-1"></div>
  <div class="btn-group">
    <button mat-stroked-button (click)="listControl(false,true)">全選択</button>
    <button mat-stroked-button (click)="listControl(true,false)">全解除</button>
  </div>
  <div class="horizontal-line-1"></div>
  <ng-container *ngIf="startRender">
    <ng-container *ngIf="filtered$ | async as staffList">
      <ul *ngIf="staffList.length > 0; else none" class="staff-list">
        <li *ngFor="let staff of staffList">
          <app-staff-item [staff]="staff" (click)="onChange(staff)" [multiSeletect]="multiple"
            [selected]="checkSelect(staff.stfcd)" [disabled]="staff.stfcd === '-1' && disabledEmpty "></app-staff-item>
        </li>
      </ul>
      <ng-template #none>
        <p class="list-none">表示するデータがありません</p>
      </ng-template>
    </ng-container>
  </ng-container>
</div>

<ng-template #groupfield>
  <app-search-group-field [form]="form" placeholder="チーム選択" [data]="staffInGroupRender" [indicatorString]="'チーム'"
    [treeControl]="treeControl" [treeFlattener]="treeFlattener"
    (selectedNode)="filterByTeam($event)"></app-search-group-field>
  <div class="horizontal-line-1"></div>
</ng-template>

<ng-template #fake>
  <div class="search">
    <input matInput [placeholder]="'チーム選択'" disabled [ngStyle]="{'font-size': '15px'}" />
  </div>
</ng-template>